module.exports = __webpack_public_path__ + "static/media/ico_invisible.e477c332.svg";